import { MerchantsList } from "./helpers";

export const getPaymentMethodNameType = (paymentMethod: PaymentMethod): { name: string, type: SelectedPaymentMethod } => {
  if (!paymentMethod || paymentMethod.source === MerchantsList.SPS_ECOMMERCE || !paymentMethod.source) {
    return { name: 'creditcard', type: 'traditional' }
  }

  return { name: paymentMethod.source.toLowerCase(), type: 'alternative' }
}
